import router from './router'
import { setDocumentTitle } from './utils'
import storage from './utils/storage'
import defaultConfig from './configs/default.config'
import { useUserStore, useDataStore } from './store'
import { RouteRecordRaw } from 'vue-router'

const whiteList = ['iot-login', 'iot-regist', 'iot-forget', 'iot-forgetpsw']
export default {
  init() {
    console.log('载入路由')
    const userStore = useUserStore()
    const dataStore = useDataStore()
    router.beforeEach((to, from, next) => {
      to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${to.meta.title} - ${defaultConfig.project_title}`))
      if (storage.get('BEARER_TOKEN')) {
        if (userStore.menus.length === 0) {
          userStore.onGetUserInfo().then(() => {
            userStore.onGetMenus().then((resp) => {
              dataStore.onGetIndustrys().then(() => {
                userStore.GenerateRoutes(resp).then((routes: any) => {
                  routes.forEach((element: RouteRecordRaw) => {
                    router.addRoute(element)
                  })
                  next({ ...to, replace: true })
                })
              })
            })
          })
        } else {
          if (to.name === 'iot-login') {
            next({ name: 'iot-control' })
          } else {
            next()
          }
        }
      } else {
        userStore.menus = []
        // 返回登陆
        if (whiteList.includes(to.name as string)) {
          next()
        } else {
          next({ name: 'iot-login' })
        }
      }
    })

    router.afterEach(() => {
      console.log('done')
    })
  }
}